
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/release-notes",
      function () {
        return require("private-next-pages/release-notes.js");
      }
    ]);
  